import { render, staticRenderFns } from "./embedded_iframe.vue?vue&type=template&id=0a5ad456"
import script from "./embedded_iframe.vue?vue&type=script&lang=js"
export * from "./embedded_iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports